module.exports = __webpack_public_path__ + "img/step-6.34b68c2d.png";